import React from 'react'

export interface SubMenuProps {
    /** Button contents */
    options: SubMenuOption[]
}

interface SubMenuOption {
    /** Option component */
    children: React.ReactNode
    /** Marks an option as selected **/
    selected: boolean
    /** Handle on click for that option **/
    onClick: () => void
}

/**
 * Default sub menu component for click interactions
 */
export function SubMenu({ options }: SubMenuProps) {
    return (
        <div className={`border-b-4 border-gray2`}>
            {options.map((option, index) => {
                const optionClasses = [
                    'inline-flex items-center justify-center cursor-pointer',
                    'px-4 py-2',
                    'rounded-none',
                    'relative',
                    'transition-colors duration-250',
                    option.selected
                        ? 'hover:border-black'
                        : 'hover:border-gray3',
                    `border-b-4 ${
                        option.selected ? 'border-current' : 'border-gray2'
                    } `,
                    `text-sm ${
                        option.selected ? 'text-current' : 'text-gray3'
                    } `,
                    `${option.selected ? 'font-bold' : 'font-normal'}`,
                ].join(' ')
                return (
                    <span
                        className={`${optionClasses}`}
                        style={{ bottom: -4 }}
                        onClick={option.onClick}
                        key={`menu-${index}`}>
                        {option.children}
                    </span>
                )
            })}
        </div>
    )
}
